import { useEffect, useState, useRef } from "react";
import style from "./Topbar.module.css";
import { FaUserCircle, FaRegBell } from "react-icons/fa";
import { RiApps2AiLine, RiFontSize } from "react-icons/ri";
import logoIteraBranca from "../../assets/logoIteraBranca.png";
import ModalUsuarioInfo from "./modalUsuarioInfo/ModalUsuarioInfo";
import ModalMensagem from "./modalMensagem/ModalMensagem";
import ModalApps from "./modalApps/ModalApps";
import NotificacaoApi from "../../services/NotificacaoApi";

import FotosApi from "../../services/FotosApi";
import { IoIosTime } from "react-icons/io";
import ModalFrequencia from "./modalFrequencia/ModalFrequencia";
import ValidarPermissao from '../../services/ValidarPermissao';
import FuncionalidadesNome from "../../constants/FuncionalidadesNome";



function Topbar({ children, menuHamburguerAberto, setMenuHamburguerAberto }) {
  const [mostrarModalUsuario, setMostrarModalUsuario] = useState(false);
  const [mostrarModalMensagem, setMostrarModalMensagem] = useState(false);
  const [mostrarModalApp, setMostrarModalApp] = useState(false);
  const [mostrarModalFrequencia, setMostrarModalFrequencia] = useState(false);
  const [quantidadeNotificacoesNaoLidas, setQuantidadeNotificacoesNaoLidas] =
    useState(0);

  const [foto, setFoto] = useState(() => localStorage.getItem("fotoUsuario") || null);
  const fotoUrlRef = useRef(null); // para guardar o URL criado



  const botaoFrequenciaRef = useRef(null);
  const botaoPlataformaRef = useRef(null);
  const botaoMensagensRef = useRef(null);
  const botaoperfilRef = useRef(null);
  const ExibirItemFrequencia = ValidarPermissao.validar(FuncionalidadesNome.ExibirItemTopbarAtalhoFrequencia);

  async function QuantidadeNotificacoesNaoLidas() {
    try {
      const quantidade =
        await NotificacaoApi.QuantidadeNotificacoesUsuarioAsync();
      setQuantidadeNotificacoesNaoLidas(quantidade);
    } catch (error) { }
  }


  async function ObterFoto() {
    try {
      const blob = await FotosApi.ObterFoto();

      if (blob && blob.size > 0) {

        if (fotoUrlRef.current) {
          URL.revokeObjectURL(fotoUrlRef.current);
        }

        const novaUrl = URL.createObjectURL(blob);


        if (novaUrl !== fotoUrlRef.current) {
          fotoUrlRef.current = novaUrl;
          setFoto(novaUrl);
          localStorage.setItem("fotoUsuario", novaUrl);
        }
      } else {
        setFoto(null);
        localStorage.removeItem("fotoUsuario");
      }
    } catch (error) {

    }
  }

  useEffect(() => {
    const FotoAtualizada = (event) => {

      const novaFoto = event?.detail || localStorage.getItem("fotoUsuario");
      setFoto(novaFoto);
    };

    window.addEventListener("fotoAtualizada", FotoAtualizada);

    return () => {
      window.removeEventListener("fotoAtualizada", FotoAtualizada);
    };
  }, []);


  useEffect(() => {
    ObterFoto()
    QuantidadeNotificacoesNaoLidas();
  }, []);
  return (
    <div>
      <div className={style.topbar_conteudo}>
        <div className={style.container_menu_logo}>
          <div className={style.container_menu_hamburguer}>
            {/* <MenuHamburguer
              menuHamburguerAberto={menuHamburguerAberto}
              setMenuHamburguerAberto={setMenuHamburguerAberto}
            /> */}
          </div>
          <div className={style.container_logo}>
            <a href="/"><img src={logoIteraBranca} alt="Logo da itera360" /></a>
          </div>
        </div>

        <div className={style.container_info}>
          {ExibirItemFrequencia &&
            <div>
              <button
                ref={botaoFrequenciaRef}
                onClick={() => setMostrarModalFrequencia((prev) => !prev)}
                className={style.botoes_modais}
              >
                <IoIosTime className={style.icone_relogio} />
              </button>
              <ModalFrequencia
                mostrar={mostrarModalFrequencia}
                aoFechar={() => setMostrarModalFrequencia(false)}
                botaoRef={botaoFrequenciaRef}
              />
            </div>}

          <div>
            <button
              ref={botaoPlataformaRef}
              onClick={() => setMostrarModalApp((prev) => !prev)}
              className={style.botoes_modais}
            >
              <RiApps2AiLine />
            </button>
            <ModalApps
              mostrar={mostrarModalApp}
              aoFechar={() => setMostrarModalApp(false)}
              botaoRef={botaoPlataformaRef}
            />
          </div>

          <div>
            <button
              ref={botaoMensagensRef}
              onClick={() => setMostrarModalMensagem((prev) => !prev)}
              className={style.botoes_modais}
            >
              <FaRegBell />
              {quantidadeNotificacoesNaoLidas > 0 && <div className={style.exibir_numero_notificacoes}>
                <span className={style.numero_notificacoes}>
                  {quantidadeNotificacoesNaoLidas}
                </span>
              </div>}
            </button>
            <ModalMensagem
              mostrar={mostrarModalMensagem}
              aoFechar={() => setMostrarModalMensagem(false)}
              botaoRef={botaoMensagensRef}
            />
          </div>

          <div>
            <button
              ref={botaoperfilRef}
              onClick={() => setMostrarModalUsuario((prev) => !prev)}
              className={style.botoes_modais}
            >


              {foto ? (
                <img
                  src={foto}
                  alt="Foto do usuário"
                  className={style.imagemBotao}
                />
              ) : (
                <FaUserCircle size={30} />
              )}
            </button>

            <ModalUsuarioInfo
              mostrar={mostrarModalUsuario}
              aoFechar={() => setMostrarModalUsuario(false)}
              botaoRef={botaoperfilRef}
            />
          </div>
        </div>
      </div>

      <div className={style.pagina_conteudo}>{children}</div>
    </div >
  );
}

export default Topbar;
